export default "__VITE_ASSET__fgN84PNM__"